import type { FaireProductEntity } from "../../entity_types/product";

export const p_yt6e2zydfr: FaireProductEntity = {
  token: "p_yt6e2zydfr",
  type: "product",
  name: "Enamel Guitar Pins",
  brandName: "Gifts Amazing!",
  imageUrl:
    "https://cdn.faire.com/fastly/580d8bbfe789c07e672b0334c90e65f86c6d6b8b325b3344712ea37d3308bd8d.jpeg",
  priceDollars: 2,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/e78e5c93356d74a5b3c5a39c7ab7cfb005ec18fc84468a74890a6098ffa34038.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
